export enum ModificationTypeStatus {
Active,
InActive,
}
